import React, { useEffect, useState } from "react";
import CrudPage from "@/components/CrudPage";
import { groupHomesApi, providersApi } from "@/lib/orgApi";

const GroupHomesPage = () => {
    const [providers, setProviders] = useState([]);
    useEffect(() => {
        providersApi.list().then(setProviders).catch(() => setProviders([]));
    }, []);
    return (
        <CrudPage
            title="Group Homes"
            subtitle="Physical group-home locations under each provider."
            api={groupHomesApi}
            testidPrefix="group-homes"
            columns={[
                { key: "name", label: "Name" },
                {
                    key: "provider_id",
                    label: "Provider",
                    render: (r) =>
                        providers.find((p) => p.id === r.provider_id)?.name ||
                        "—",
                },
                { key: "license_number", label: "License #" },
                {
                    key: "active",
                    label: "Status",
                    render: (r) =>
                        r.active ? (
                            <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                                Active
                            </span>
                        ) : (
                            <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                                Inactive
                            </span>
                        ),
                },
            ]}
            fields={[
                {
                    name: "provider_id",
                    label: "Provider",
                    type: "select",
                    required: true,
                    options: providers.map((p) => ({
                        value: p.id,
                        label: p.name,
                    })),
                },
                { name: "name", label: "Group Home name", required: true },
                { name: "address", label: "Address" },
                { name: "phone", label: "Phone" },
                { name: "license_number", label: "License number" },
                {
                    name: "active",
                    label: "Active",
                    type: "boolean",
                    default: true,
                },
            ]}
        />
    );
};

export default GroupHomesPage;
